import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterToolbar = ({ 
  filters, 
  onFilterChange, 
  onReset,
  onCreateNew,
  createButtonLabel = '새 세션 만들기',
  createMenuOpen = false,
  createMenuItems = null,
  onSelectCreateType = null
}) => {
  const eventTypeOptions = [
    { value: 'all', label: '전체 이벤트' },
    { value: 'open_game', label: '오픈게임' },
    { value: 'lesson', label: '레슨' },
    
  ];

  const statusOptions = [
    { value: 'all', label: '모든 상태' },
    { value: 'open', label: '등록 가능' },
    { value: 'full', label: '정원 마감' },
    { value: 'closed', label: '등록 마감' },
    { value: 'completed', label: '완료됨' },
    { value: 'cancelled', label: '취소됨' }
  ];

  const sortOptions = [
    { value: 'date-asc', label: '날짜 (빠른순)' },
    { value: 'date-desc', label: '날짜 (늦은순)' },
    { value: 'participants-desc', label: '참가자 (많은순)' },
    { value: 'participants-asc', label: '참가자 (적은순)' },
    { value: 'created-desc', label: '생성일 (최신순)' },
    { value: 'created-asc', label: '생성일 (오래된순)' }
  ];

  const handleSearchChange = (e) => {
    onFilterChange({ search: e?.target?.value });
  };

  const handleEventTypeChange = (value) => {
    onFilterChange({ eventType: value });
  };

  const handleStatusChange = (value) => {
    onFilterChange({ status: value });
  };

  const handleSortChange = (value) => {
    onFilterChange({ sort: value });
  };

  const handleDateFromChange = (e) => {
    onFilterChange({ dateFrom: e?.target?.value });
  };

  const handleDateToChange = (e) => {
    onFilterChange({ dateTo: e?.target?.value });
  };

  return (
    <div className="bg-card border border-border rounded-xl p-4 md:p-6">
      <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4 mb-6">
        <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground">
          오픈 게임
        </h2>

        <div className="relative">
          <Button
            variant="default"
            size="default"
            iconName="Plus"
            iconPosition="left"
            onClick={onCreateNew}
          >
            {createButtonLabel}
          </Button>

          {createMenuOpen && Array.isArray(createMenuItems) && createMenuItems.length > 0 && (
            <div className="absolute right-0 top-full mt-1 z-50 w-64">
              <div className="bg-card rounded-2xl border border-border shadow-elevation-4 p-3">
                <p className="text-xs text-muted-foreground mb-2">이벤트 종류 선택</p>
                <div className="grid grid-cols-1 gap-2">
                  {createMenuItems.map((item) => (
                    <button
                      key={item.type}
                      type="button"
                      onClick={() => {
                        if (typeof onSelectCreateType === 'function') onSelectCreateType(item.type);
                      }}
                      className="w-full flex items-center justify-between px-4 py-2.5 rounded-xl border border-border bg-background hover:bg-muted transition-athletic"
                    >
                      <span className="text-sm font-semibold text-foreground">{item.label}</span>
                      <span className="text-muted-foreground">›</span>
                    </button>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          <Input
            type="search"
            placeholder="세션 제목 검색..."
            value={filters?.search}
            onChange={handleSearchChange}
          />

          <Select
            options={eventTypeOptions}
            value={filters?.eventType}
            onChange={handleEventTypeChange}
            placeholder="이벤트 종류"
          />

          <Select
            options={statusOptions}
            value={filters?.status}
            onChange={handleStatusChange}
            placeholder="상태 선택"
          />

          <Select
            options={sortOptions}
            value={filters?.sort}
            onChange={handleSortChange}
            placeholder="정렬 기준"
          />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <Input
            type="date"
            label="시작 날짜"
            value={filters?.dateFrom}
            onChange={handleDateFromChange}
          />

          <Input
            type="date"
            label="종료 날짜"
            value={filters?.dateTo}
            onChange={handleDateToChange}
          />
        </div>

        <div className="flex justify-end">
          <Button
            variant="ghost"
            size="sm"
            iconName="RotateCcw"
            iconPosition="left"
            onClick={onReset}
          >
            필터 초기화
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FilterToolbar;